<template>
    <div class="chartElem">


        <highcharts class="chart" :options="chartOptions" :updateArgs="updateArgs" :callback="InitChartFunction">
        </highcharts>
        <!-- <div>Clickedpoint on chart:
            <div>clickpoint.x:{{clickpoint.x}}</div>
            <div>clickpoint.y:{{clickpoint.y}}</div>
        </div>

        <div>Clickedcutpoint:
            <div>cutpoint.x:{{cutpoint.x}}</div>
            <div>cutpoint.y:{{cutpoint.y}}</div>
        </div> -->
        <div class="p-5">
            <div class="row small">
                <div class="col-12 col-md-4"
                    v-if="calculatedpoint.volumeflow!=null || calculatedpoint_polynomial.sl_k_pfs!=null">
                    <h6>{{__('lang.highcharts.op') + __('lang.highcharts.op.is')}}</h6>
                    <div v-if="product_data.max_angle>0 && wsoll > product_data.max_angle" class="text-primary">{{__('lang.highcharts.op.is.invalid')}}  {{__('lang.highcharts.op.is.invalid.maxangle')}} {{product_data.max_angle}}{{__('lang.units.degree_short')}}</div>
                    <div v-else>
                    <table class="table table-sm table-striped table-borderless mb-3">
                        <tbody>
                            <tr>
                                <th class="border-right" scope="row">{{__('lang.airflowrate')}} q <span
                                        style="font-size:10px">v</span></th>
                                <td>{{calculatedpoint.volumeflow + ' '+ chartproperties.units.airflow_unit}}</td>
                            </tr>
                            <tr>
                                <th class="border-right" scope="row">{{chartproperties.yAxisPressureTyp}} P<span
                                        style="font-size:10px">{{ chartproperties.yAxisPressureTypShort }}</span></th>
                                <td>{{calculatedpoint.pressure + ' ' +chartproperties.units.externalpressure_unit }}
                                </td>
                            </tr>
                            <tr  v-show="wsoll > 0 && wsoll!=1111" >
                               <!--  <th class="border-right" scope="row">{{curvekeyunit_label}}</th> -->
                               <th class="border-right" scope="row">{{ __('lang.highcharts.interpolated') }}</th>
                               <td>{{ calculatedpoint_polynomial.sl_k_pfs ? calculatedpoint_polynomial.sl_k_pfs : (curvekeyunit_label== __('lang.highcharts.interpolated') ? calculatedpoint.wsoll:
                                parseFloat(calculatedpoint.wsoll).toFixed(2))}} {{chartproperties.curvekeyunit}}

                                </td>
                            </tr>
                            <tr v-show="electricity>0">
                                <th class=" border-right" scope="row">
                                    {{__('lang.global.product.tabs.curves.electricity')}}</th>
                                <td>{{ electricity }}
                                    {{__('lang.units.amper')}}</td>
                            </tr>
                            <tr v-show="elpower>0">
                                <th class="border-right" scope="row">{{__('lang.global.product.tabs.curves.elpower')}}
                                </th>
                                <td>
                                    {{ elpower.toFixed(2)}} {{__('lang.units.kilowatt')}} </td>
                            </tr>
                            <tr
                                v-show="wsoll > 0 && curvekeyunit_label != this.__('lang.global.product.tabs.curves.voltage') && curvekeyunit_label != this.__('lang.highcharts.interpolated') && curvekeyunit_label != this.__('lang.percent')">
                                <th class="border-right" scope="row">{{ calculatedpoint_polynomial.sl_k_pfs ||
                                parseFloat(calculatedpoint.wsoll).toFixed(2) > 0 ?
                                curvekeyunit_label
                                : __('lang.global.product.tabs.curves.voltage')
                                }}
                                </th>
                                <td>{{
                                calculatedpoint_polynomial.sl_k_pfs ?
                                calculatedpoint_polynomial.sl_k_pfs + ' '+chartproperties.curvekeyunit :
                                (parseFloat(calculatedpoint.wsoll).toFixed(2) > 0 ? (curvekeyunit_label == this.__('lang.highcharts.interpolated') ?  Math.ceil(calculatedpoint.wsoll) :
                                         Math.ceil(parseFloat(calculatedpoint.wsoll).toFixed(2))) +
                                ''+chartproperties.curvekeyunit : voltage + __('lang.units.volt'))}}</td>


                            </tr>
                            <tr v-show="rpm >0">
                                <th class="border-right" scope="row">{{__('lang.global.product.tabs.curves.rpm')}}</th>
                                <td>{{ rpm}}
                                    {{__('lang.units.rpm')}}
                                </td>
                            </tr>
                            <tr v-show="sfp >0">
                                <th class="border-right" scope="row">{{__('lang.global.product.tabs.curves.sfp')}}</th>
                                <td>{{sfp }} {{__('lang.units.sfp')}}</td>
                            </tr>

                            <!-- <tr>
                        <th class="small border-right align-middle" scope="row">{{__('lang.acoustic')}}</th>
                        <td>{{calculatedpoint.acoustic}}</td>
                    </tr> -->

                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="col-12 col-md-4"></div>
                <!-- if($artikel['prod_gr']=='L' or $artikel['prod_gr']=='Z' or ($artikel['prod_gr']=='I' and substr(strtolower($artikel['artbez1']),0,3)!='hrf'))
                   $return.='<div id="einbau" style="float:left;display:inline;"><img src="images/einbau_rv.png" style="width: 300px; height: auto"></div>';    zeig bild einbau

                    keine prod_gr in heliosselect2.0
                     product_data.prodgroup entspricht waren_gr aus heliosselect1.0
                   product_data.prodgroup=='L' || product_data.prodgroup=='Z'|| (product_data.prodgroup=='I' && product_data.type.toLowerCase().substr(0,3)!='hrf')


                TODO: Kriterium wann dieses Bild angezeigt werden soll:
            product_data.type.toLowerCase().substr(0, 3) != 'hrf' &&
            //Nehf 20231018:
            product_data.type.toLowerCase().substr(0, 3) != 'kwl'
            -->

                <div class="col-12 col-md-4" v-show="product_data.flag_pipelineimage == 1">
                    <img class="img-fluid" src="/images/einbau_rv.png">
                </div>
            </div>

            <!-- <div>
            Volumenstrom	9009 m³/h
            statischer Ventilatordruck	243 Pa
            Anstellwinkel	22°
            Totaler Wirkungsgrad	70 %
            Pwelle	1.01 kW
            Schallleistungspegel	86.12 dB(A)
            </div> -->

        </div>
        <!--

            //TVolle: 17.01.2019 Luftleistung Hinweis fÃƒÂ¼r BAVD einblenden
	  		//Gerigk: 26.08.2021 B AMD und VARD auch
	        //Landmesser: 20.02.2023 F600 soll ausgeschlossen sein
			if(stripos($messnr['bsel_artnr'],'FAN')!==false ||
               (stripos($artikel['artbez1'],'B AMD')!==false && stripos($artikel['artbez1'],'F600')==false) ||
               (stripos($artikel['artbez1'],'B VARD') !==false && stripos($artikel['artbez1'],'F600')==false ))
			            $luftleist_hinweis=true;


            FAN=B AVD

            if($luftleist_hinweis==true   zeig airpower_txt-->
        <div class="rounded bg-info small p-3"
            v-if="product_data.type.substr(0,5)=='B AVD' || (product_data.type.substr(0,5)=='B AMD'  && product_data.type.indexOf('F600') ==-1 )|| (product_data.type.substr(0,6)=='B VARD' &&  product_data.type.indexOf('F600') == -1)">
           <!-- TODO: Kriterium wann diese Info angezeigt werden soll:  -->
            <b>{{__('lang.global.product.highcharts.airpower_head')}}: </b>
            {{__('lang.global.product.highcharts.airpower_txt')}}

        </div>
        <!--  <div v-if="product_data.volumeflow==null || calculatedpoint.volumeflow==null || parseFloat(product_data.volumeflow).toFixed(2)!= parseFloat(calculatedpoint.volumeflow).toFixed(2)">
            <p>{{__('lang.highcharts.op') + __('lang.highcharts.op.must')}}</p>
            <p>Hier sollen input OP Werte stehen</p>
        </div>    -->
    </div>
</template>

<script>
    import {EventBus}  from  './services/eventbus/event-bus'
    import productdataApi from './services/api/productdataAPI.js'

    function getnewgraph(maxvol,maxdruck,bp_a,bez,farbe, airflow_unit, pressure_unit){
        var parabel =  [];
                       var iY;
                       var k=0;
                       var schritt=1;

                       if(maxvol > 0) k = (bp_a>0?bp_a:0);

                       for (var iX=0; iX < maxvol+schritt;) {
                         if(iX==0) iY=0;
                         else iY = k * Math.pow(iX, 2);
                         if(iY>maxdruck*1.02) break;

                          parabel.push([iX,iY]);
                          if ( maxvol > 100000) {
                              schritt = 1000;
                          }
                          else if ( maxvol <= 100000 && maxvol > 50000) {
                              schritt= 100;
                          }
                          else if (maxvol <= 50000 && maxvol > 10000){
                            schritt= 50;
                          }
                          else if (maxvol <= 10000 && maxvol > 1000){
                             schritt= 5;
                          }
                          else if (maxvol <= 1000 && maxvol > 100){
                             schritt= 1;
                          }
                          else {
                              schritt= 0.2;
                          }
                        iX+=schritt;
                       }
                      var par_farbe;
                      if(!bez) bez='';


                      if(farbe=='unzbereich' ) par_farbe='rgb(255, 255, 0)';
                      else par_farbe=(farbe?farbe:"rgb(255, 0, 0)");
                      var ret_parabel={
                          name: bez,
                          data:parabel,
                          dashStyle: 'shortdot',
                          lines: {
                               show: true,
                               lineWidth: 1
                          },
                          points: {
                              show: false
                          },
                          color: par_farbe,
                          airflow_unit: airflow_unit,
                          externalpressure_unit:pressure_unit
                        };

                     return ret_parabel;
    }

    export default {
        props:['ismobile'],
        computed: {
            product_data:{
                get () {
    			    return this.$store.state.productdata.product_data
    		    },
            },
            curves:{
                get () {
                  return this.$store.state.productdata.curves
                },
                set(value){
                    this.$store.commit('productdata/setCurvesData',value);
                }
            },
            chartproperties:{
                get () {
                  return this.$store.state.productdata.chartproperties
                },
                set(value){
                    this.$store.commit('productdata/setChartpropertiesData',value);
                }
            },
            calculatedpoint:{
                get () {
                  return this.$store.state.productdata.calculatedpoint
                },
                set(value){
                    this.$store.commit('productdata/setCalculatedPointData',value);
                }

            },
            op : {
              get () {
                  //return this.$store.state.operatingpoint.op
                  return this.$store.state.productdata.op

              }
            },
            calculatedpoint_polynomial: {
              get () {
                  //return this.$store.state.operatingpoint.op
                    return this.$store.state.productdata.calculatedpoint_polynomial

              },
              set(value){
                    this.$store.commit('productdata/setCalculatedPointPolynomial',value);
                }
            },
            curvekeyunit_label: function(){
                if(this.chartproperties.curvekeyunit=='V') return this.__('lang.voltage')
                else if (this.chartproperties.curvekeyunit == '°') return this.__('lang.global.product.tabs.techdata.angle')
                else if (this.chartproperties.curvekeyunit == '%') return this.__('lang.percent')
                else  return this.__('lang.highcharts.interpolated')


            },
            voltage: function () {
                var v1 = this.product_data.voltage1
                var v2 = this.product_data.voltage2
                var phase = this.product_data.phase
                var f1 = this.product_data.frequency1
                var f2 = this.product_data.frequency2


                var return_str = (v1 > 0 ? v1 : '') + ((v1 > 0 && v2 > 0) ? ' / ' : '') + (v2 > 0 ? v2 : '') + ((v1 > 0 || v2 > 0) ? this.__('lang.units.volt') + ' / ' : '') +
                    (phase > 0 ? phase + ' ' + this.__('lang.units.ph') + ' / ' : '') + (f1 > 0 ? f1 : '') + ((f1 > 0 && f2 > 0) ? ' / ' : '') + (f2 > 0 ? f2 : '') + ((f1 > 0 || f2 > 0) ? this.__('lang.units.hz') : '')

                return return_str


            },
            electricity: function () {
                return this.calculatedpoint_polynomial.sl_k_pfs ? this.calculatedpoint_polynomial.sl_k_iges.toFixed(3) : this.calculatedpoint.electricity.toFixed(3)
            },
            elpower: function () {
                return this.calculatedpoint_polynomial.sl_k_pfs ?
                    this.calculatedpoint_polynomial.sl_k_pel.toFixed(2) / 1000 :
                    this.calculatedpoint.elpower.toFixed(2) / 1000
            },
            wsoll: function () {
                return this.calculatedpoint_polynomial.sl_k_pfs ?
                    this.calculatedpoint_polynomial.sl_k_pfs :
                    parseFloat(this.calculatedpoint.wsoll).toFixed(2)

            },
            rpm: function () {
                return this.calculatedpoint_polynomial.sl_k_pfs ?
                    this.calculatedpoint_polynomial.sl_k_n.toFixed(0) : this.calculatedpoint.rpm.toFixed(0)
            },
            sfp: function () {
                return this.calculatedpoint_polynomial.sl_k_pfs ? this.calculatedpoint_polynomial.sfp.toFixed(3) :
                    this.calculatedpoint.sfp.toFixed(3)
            }








        },
        data() {

			return {
                clickpoint:{
                    x:100,
                    y:200
                },
                cutpoint:{
                    x:null,
                    y:null
                },
                title: 'Testtitle',
            /*    points: [10, 0, 8, 2, 6, 4, 5, 5],
                chartType: 'Spline',
                seriesColor: '#6fcd98',
                colorInputIsSupported: null,
                animationDuration: 1000,
            */
                updateArgs: [true, true, {duration: 1000}],
                chartOptions: {
                    exporting:{
                        libURL:'/js/'
                    },
                    chart: {

                        defaultSeriesType: 'spline',
                        style: {
                              fontFamily: '"Roboto",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
                        },
                        events: {
                            click: (e) => {
                                //console.log('chartOptions events:')

                                this.NewOPPointClicked(e.xAxis[0].value, e.yAxis[0].value)
                                //this.NewPointClicked(e)
                             }

                        },
                        height: (this.ismobile == 'desktop' ? (9 / 16 * 100) + '%' : '100%'), // 16:9 ratio,
                        zooming: {
                            mouseWheel: {
                                enabled: false
                            }
                        },

                    },
                    lang: {
                        noData: this.__('lang.highcharts.nodata'),
                    },
                    noData: {
                        style: {
                            /*fontSize: '15px',*/
                            color: '#e0001e'
                        },
                        position: {
                            align: 'center',
                            verticalAlign: 'top',

                        }
                    },
                    colors: ['#012641', '#cc0001', '#ff9600', '#0065ff', '#64318d', '#006432', '#4c7dc9', '#b4b4b4', '#ff6364', '#fedc32', '#64c7fe', '#af83ff', '#95c83b', '#525252'],
                    title: {
                        text: '',
                        style: {
                            color: '#333',
                            fontSize: '1.5em',
                            fontWeight: 'normal',
                        }

                    },
                    subtitle: {
                        text: ''
                    },
                    credits: {
                        enabled: true,
                        text: 'heliosventilatoren.de',
                        href: 'https://www.heliosventilatoren.de'
                    },
                    xAxis: {
                        crosshair: {
                            snap: false,
                            dashStyle: 'dash',
                            label: {
                                backgroundColor: 'rgb(147,147,147)',
                                formatter: function (value) {
                                    //return 'Airflow: ' + value.toFixed(2);
                                    return  value.toFixed(2);
                                },
                                enabled: true,
                                padding: 8
                            }
                        },
                        lineWidth: 0,
                        tickWidth: 0,
                        gridLineWidth: 1,
                        labels: {
                            formatter: function () {
                                return this.value;
                            },
                            style: {
                                color: 'rgb(0, 0, 0)',
                            }
                        },
                        maxPadding: 0.05,
                        min: 0,
                        title: {
                            style: {
                                color: 'rgb(0, 0, 0)',
                                /*fontWeight: 'bold',*/
                                fontSize: '12px',
                            },
                            text: ''
                        },
                        tickmarkPlacement: 'on',
                        endOnTick: true,  //an xachse am ende bleibt noch platz
                        showLastLabel: true, //an xachse letzter wert

                    },
                    yAxis: {
                        crosshair: {
                            snap: false,
                            dashStyle: 'dash',
                            interpolate: true,
                            label: {
                                backgroundColor: 'rgb(209,209,209)',
                                formatter: function (value) {
                                   // return 'Pressure'  + value.toFixed(2);
                                    return  value.toFixed(2);
                                },
                                enabled: true,
                                padding: 8
                            }
                        },
                        labels: {
                            formatter: function () {
                                return this.value;
                            },
                            style: {
                                color: '#000000'
                            }
                        },
                        min: 0,
                        gridLineWidth: 1,
                        title: {
                            text: '',
                            style: {
                                color: 'rgb(0, 0, 0)',
                                fontSize: '12px',
                            },
                            rotation: 270, //default
                            x: -10,
                        }
                    }, /*
                    responsive: true,
                   plugins: {
                        legend: {
                            display: false
                        }
                    },

                    responsive: {
                        rules: [{
                            condition: {
                                minHeight: 400
                            },

                        }]
                    },
                    */
                    legend: {
                        enabled:(this.ismobile=='mobile'?false:true),
                        layout: 'horizontal',
			            align: 'center',
			            verticalAlign: 'bottom'

                    },
                    plotOptions: {
                        series: {
                            allowPointSelect: true,

                            events: {
                                click: function (event) {
                                    EventBus.$emit("seriesClicked", event.point);
                                }
                            }
                        }
                        /*
                        series: {
                            states: {
                                hover: {
                                    enabled: false
                                }
                            }
                        }
                        */
                    },
                    tooltip: {
                        enabled: true,
                        formatter: function() {
                            return ''
                        }
		            },
                    series: [{

                    }]
                },
    		}
		},
        methods : {
            InitChartFunction() {
               console.log('callbackFunction');
            },
            OpClicked(pointdata) {
                console.log('pointdata.point:')
                console.log(pointdata.point.x + ':' + pointdata.point.y);//data of click event, One can found point's value or index
            },
            RedrawGraphforNewPoint(pointdata) {
                console.log('pointdata:')
                console.log(pointdata.x + ':' + pointdata.y);//data of click event, volumeflow and pressure
                this.op.airflow = pointdata.x
                this.op.pressure = pointdata.y

                this.getProductCurves()





            },
            NewPointClicked(event) {
                console.log('event:');
                console.log(event);//data of click event, One can found point's value or index
                var seriesLength = this.chartOptions.series.length;
                console.log('seriesLength:');
                console.log(seriesLength);
                /*this part is for draw parabel and new point, we dont need it because graph would be redraw with this.getProductCurves()
                if(this.chartOptions.series[this.chartOptions.series.length-1].name == this.__('lang.highcharts.newoppoint')){
                            // this.chartOptions.series[this.chartOptions.series.length-1].remove(); // remove point
                            this.chartOptions.series.pop();
                            //-- this.chartOptions.series[this.chartOptions.series.length-1].remove();  // remove parabola
                            this.chartOptions.series.pop();
                }
                var new_parab_mbp=getnewgraph(event.xAxis[0].value,event.yAxis[0].value,event.yAxis[0].value/(event.xAxis[0].value*event.xAxis[0].value),
                                            this.__('lang.highcharts.newopparabola'),'rgb(215,67, 77)',
                                            this.chartproperties.units.airflow_unit,this.chartproperties.units.externalpressure_unit);

                //this.chartOptions.addSeries(new_parab_mbp);
                this.chartOptions.series.push(new_parab_mbp);
                //this.chartOptions.addSeries({
                this.chartOptions.series.push({
                    name: this.__('lang.highcharts.newoppoint'),
                    data: [ [event.xAxis[0].value, event.yAxis[0].value] ],
                    airflow_unit: this.chartproperties.units.airflow_unit,
                    externalpressure_unit:this.chartproperties.units.externalpressure_unit,
                    marker: {
                        enabled:true,
                        symbol: 'circle',  //'url(https://www.highcharts.com/samples/graphics/sun.png)'
                        lineColor: null,
                        lineWidth: 3
                        },
                    color: 'rgb(63, 10, 170)'
                    });
                */
                this.clickpoint.x   = event.xAxis[0].value;
                this.clickpoint.y   = event.yAxis[0].value;
                this.RedrawGraphforNewPoint(this.clickpoint);



                /*
                var label = this.renderer.label(
                            'Volumen: ' + Highcharts.numberFormat(event.xAxis[0].value, 2) + ', Druck: ' + Highcharts.numberFormat(event.yAxis[0].value, 2),
                            event.xAxis[0].axis.toPixels(event.xAxis[0].value),
                            event.yAxis[0].axis.toPixels(event.yAxis[0].value)
                        )
                    .attr({
                        fill: Highcharts.getOptions().colors[0],
                        padding: 10,
                        r: 5,
                        zIndex: 8
                    })
                    .css({
                        color: '##FF0099'
                    })
                    .add();

                setTimeout(function () {
                    label.fadeOut();
                }, 4000); */
            },
            NewOPPointClicked(x_volumeflow, y_pressure) {

                this.clickpoint.x = x_volumeflow;
                this.clickpoint.y = y_pressure;
                this.RedrawGraphforNewPoint(this.clickpoint);


            },




            getCurvesData:function(){
                this.chartOptions.title.text = this.__('lang.highcharts.title') + ' (' + this.__('lang.highcharts.density') +' ρ='+ this.chartproperties.rho + ' kg/m³)'
                this.chartOptions.subtitle.text = '' //'n=' + this.product_data.max_rpm +' 1/min'


                this.chartOptions.xAxis.title.text = this.__('lang.airflowrate') + ' q <span style="font-size:10px">v</span> ['+ this.chartproperties.units.airflow_unit + ']'
                this.chartOptions.yAxis.title.text = this.chartproperties.yAxisPressureTyp + ' P<span style="font-size:10px">'+ this.chartproperties.yAxisPressureTypShort +'</span> ['+this.chartproperties.units.externalpressure_unit+']'


                var tooltip = {
                    enabled: true,
                    formatter:  function() {

                                return   '<b>'+ this.series.name +'</b><br/>'
                                    +  Math.round(this.x*100)/100 + this.series.userOptions.airflow_unit +'<br/>'
                                    +  Math.round(this.y*100)/100 + this.series.userOptions.externalpressure_unit
                    }
                    //.bind(this)

                }

                this.chartOptions.tooltip=tooltip
                var seriesArr = []
                var series = {}

                this.curves.forEach(function (curvesdata) {
                    var points= curvesdata.points  //set in  store/modules/ProductData.js
                    var curvename = curvesdata.name
                    var curvegroup = curvesdata.curvegroup
                            if(curvename =='op') {
                                curvename=this.__('lang.highcharts.'+ curvename)+' '+this.__('lang.highcharts.op.must')
                                series = {
                                    name : curvename,
                                    data : points,
                                    airflow_unit: this.chartproperties.units.airflow_unit,
                                    externalpressure_unit:this.chartproperties.units.externalpressure_unit,
                                    fillOpacity:.2,
                                    lineWidth: 3,
                                    fillColor: 'rgba(127, 127, 220, 0.1)',
                                    marker: {
                                        enabled:true,
                                        symbol: 'circle',
                                        lineColor: null,
                                        lineWidth: 3
                                        },
                                    color: 'rgb(0, 0, 255)',
                                    point: {
                                        events: {
                                            click: this.OpClicked.bind(this)
                                        }
                                    }
                                }
                            }
                            else if (curvename =='parabola') {
                                curvename=this.__('lang.highcharts.'+ curvename)
                                series = {
                                    name : curvename,
                                    data : points,
                                    airflow_unit: this.chartproperties.units.airflow_unit,
                                    externalpressure_unit:this.chartproperties.units.externalpressure_unit,
                                    fillOpacity:.2,
                                    lineWidth: 1,
                                    points: {
                                        show: false
                                    },
                                    marker: {
                                        enabled:false,
                                        radius: 1
                                    },
                                    color: 'rgb(255, 0, 0)'
                                }

                            }
                            else if (curvename =='interpolated') {
                                curvename=this.__('lang.highcharts.'+ curvename) + ' ' + parseFloat(this.chartproperties.wsoll).toFixed(2) +' '+ this.chartproperties.curvekeyunit
                                series = {
                                    name : curvename,
                                    data : points,
                                    airflow_unit: this.chartproperties.units.airflow_unit,
                                    externalpressure_unit:this.chartproperties.units.externalpressure_unit,
                                    color: 'rgb(92, 192, 94)',
                                    dashStyle: 'shortdot',
                                    marker: {
                                        radius: 0.5
                                    },
                                }

                            }
                            else if (curvename =='cutpoint') {
                                curvename=this.__('lang.highcharts.op')+' '+this.__('lang.highcharts.op.is')
                                series = {
                                    name : curvename,
                                    data : points,
                                    airflow_unit: this.chartproperties.units.airflow_unit,
                                    externalpressure_unit:this.chartproperties.units.externalpressure_unit,
                                    lineWidth: 3,
                                    marker: {
                                        enabled:true,
                                        symbol: 'circle',
                                        lineColor: null,
                                        lineWidth: 3
                                        },
                                    color: 'rgb(92, 192, 94)',
                                    point: {
                                        events: {
                                            click(e) {
                                                //this.chartOptions.title.text='Cutpoint Click mit Volumen:' + e.point.x + ' und Druck:'+e.point.y;
                                                EventBus.$emit("pointClicked", e.point);
                                            }
                                        }
                                    }
                                }
                            }
                            else{

                                console.log('curvesdata:')
                                console.log(curvesdata)

                                var dashStyle = 'solid'
                                var fillColor= 'rgba(127, 127, 220, 0.1)'
                                var color = null // random
                                //if(curvesdata.name=='-1') {
                                if (curvegroup == '2') {
                                    curvesdata.name = this.__('lang.highcharts.blowout.radial')
                                    dashStyle='longdash'
                                    fillColor='rgba(0, 127, 0, 0.1)'
                                    color='rgb(0, 127, 0)'

                                }  //else if (curvesdata.name=='-2') {
                                else if (curvegroup == '3'){
                                    curvesdata.name = this.__('lang.highcharts.blowout.axial')
                                    dashStyle='longdash'
                                    fillColor='rgba(0, 0, 127, 0.1)'
                                    color= 'rgb(0, 0, 127)'
                                }
                                else if (curvegroup == '4') {
                                    curvesdata.name = this.__('lang.highcharts.blowout.star') + ' ' + curvesdata.name + ' ' + this.chartproperties.curvekeyunit
                                    dashStyle = 'shortdot'
                                    fillColor = 'rgba(114, 17, 222, 0.1)'
                                    color='rgb(114, 17, 222)'
                                }
                                else if (curvegroup == '5') {
                                    curvesdata.name = this.__('lang.highcharts.blowout.staryy') + ' ' + curvesdata.name + ' ' + this.chartproperties.curvekeyunit
                                    dashStyle = 'shortdashdot'
                                    fillColor = 'rgba(0, 0, 255, 0.1)'
                                    color= 'rgb(0, 0, 255)'
                                }
                                else if (curvegroup == '6') {
                                    curvesdata.name = this.__('lang.highcharts.energysavinglevel')
                                    dashStyle = 'longdash'
                                    fillColor = 'rgba(0, 0, 255, 0.1)'
                                    color= 'rgb(0, 0, 255)'
                                }
                                else curvesdata.name = this.__('lang.highcharts.curve')+' ' + (curvesdata.name=='1111'?'Vmax': curvesdata.name +' '+ this.chartproperties.curvekeyunit)
                               // else curvesdata.name = this.__('lang.highcharts.curve')+' ' + (curvesdata.name=='1111'?'Vmax': parseInt(curvesdata.name) +' '+ this.chartproperties.curvekeyunit) // wenn z.B. werte 18.1 und 18.2 Grad => sollte wie eine KL mit 18 Grad erscheinen => parseInt(curvesdata.name)

                                series = {
                                    name :  curvesdata.name,
                                    data : points,
                                    airflow_unit: this.chartproperties.units.airflow_unit,
                                    externalpressure_unit:this.chartproperties.units.externalpressure_unit,
                                    fillOpacity:.2,
                                    dashStyle: dashStyle,
                                    lineWidth: 1,
                                    fillColor: fillColor,
                                    color: color,
                                    marker: {
                                        enabled:true,
                                        radius: 1
                                    },

                                    //color: 'rgb(0, 0, 0)'
                                }
                            }
                            seriesArr.push(series)
                    }.bind(this))
                /*console.log('seriesArr:')
                console.log(seriesArr);*/

                this.chartOptions.series = seriesArr
               /* console.log('this.chartOptions:')
                console.log(JSON.stringify(this.chartOptions))*/
            },

            async getProductCurves(){
                var params={
                ref_no: this.product_data.ref_no,
                version: this.product_data.version,
                airflowrate_dev: this.op.airflow_deviation,
                externalpressure_dev:this.op.pressure_deviation,
                airflowrate: this.op.airflow,
                externalpressure:this.op.pressure,
                externalpressuretyp:this.op.pressuretype,
                airflow_unit:this.op.airflowunits,
                externalpressure_unit:this.op.pressureunits,
                execution:this.product_data.execution,
                language_id:this.$lang().locale,


                }
                console.log('getProductCurves params:')
                console.log(params)

                productdataApi.getProductCurves(params)
                .then(response => {
                    console.log('productdataApi response:')
                    console.log(response)

                    this.curves=response.data.curves
                    this.chartproperties=response.data.chartproperties
                    this.calculatedpoint = response.data.calculatedpoint

                    if (!Object.keys(response.data.calculatedpoint_polynomial).length === 0) {
                        var calc_point_polynomial = response.data.calculatedpoint_polynomial
                        console.log('calc_point_polynomial:')
                        console.log(calc_point_polynomial)
                        let [firstKey] = Object.keys(calc_point_polynomial)
                        this.calculatedpoint_polynomial = calc_point_polynomial[firstKey]
                    }


                    this.getCurvesData();
                })
                .catch(function () {
                    console.log('getProductCurves Fehler');
                });
            },


        },
        created () {

            //this.getCurvesData();

            EventBus.$on("pointClicked", point => {
                //this.chartOptions.title.text='Cutpoint Click mit Volumen:' + point.x + ' und Druck:'+ point.y;
                this.cutpoint=point;

            });

            EventBus.$on("seriesClicked", point => {
                //this.chartOptions.title.text='Cutpoint Click mit Volumen:' + point.x + ' und Druck:'+ point.y;
                this.NewOPPointClicked(point.x,point.y)

            });
        },
        watch: {

        },
        mounted () {
            console.log('Mounted Highcharts')
            console.log(this.$parent)
            this.$parent.loaded();
            //this.$refs.prodcurves.click();
            //this.loaded();

        }
    }
</script>
<style>

</style>

